import React from 'react'
import { defaultProfilePicture } from '../../../common/Constants'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ResultProps } from './ProfileGroupResult'
import I18n from 'i18n'

const ProfileConnectionResult: React.FC<ResultProps> = (props) => {
  const displayName = `${(props.item.first_name !== null && props.item.first_name !== '') ? props.item.first_name : I18n.t('profile.show.first_name') as string} ${(props.item.last_name !== null && props.item.last_name !== '') ? props.item.last_name : I18n.t('profile.show.last_name') as string}`
  return (
    <div className='row no-margin'>
      <div className='col s12 l8 valign-wrapper search-result-margin'>
        <div className='search-result-image-container'>
          <img
            src={props.item.picture !== '' ? props.item.picture : defaultProfilePicture}
            className='responsive-img circle search-result-image'
            alt={displayName}
          />
        </div>
        <div className='overflow-text-elipsis search-result-text'>
          <Link to={`/profiles/${props.item.slug}`} target='_blank'>{displayName}</Link>
        </div>
      </div>
      <div className='col s12 l4 search-result-margin'>
        <button
          id='make-connection'
          onClick={(e) => { props.onClick(e) }}
          className='waves-effect waves-light button-primary text-primary-color background-background text-medium'
        >
          <FontAwesomeIcon icon='user-plus' />
        </button>
      </div>
    </div>
  )
}

export default ProfileConnectionResult
